import Initialiser from 'initialiser';
import _ from 'lodash';
import constants from 'utils/constants';
import { logout } from 'ducks/modules/user';
import api from 'utils/api';

// ACTION TYPES
const START_FILE_STATUS_UPDATE = 'START_FILE_STATUS_UPDATE';
const UPDATED_FILE_STATUS = 'UPDATED_FILE_STATUS';

// SYNC ACTION CREATORS
export function startFileStatus() {
    return { type: START_FILE_STATUS_UPDATE };
}
export function updatedFileStatus(file_status) {
    return { type: UPDATED_FILE_STATUS, file_status };
}

// ASYNC ACTION CREATORS
export function fetchFileStatus() {
    return async (dispatch) => {
        dispatch(startFileStatus());
        try {
            const file_status = await api.getFileStatus();
            dispatch(updatedFileStatus(file_status));
        } catch (err) {
            console.error('Error fetching file status: ', err);
            dispatch(updatedFileStatus({ error: true }));
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                return Initialiser.history.replace('/forbidden');
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            }
        }
    };
}

// REDUCER
export default function reducer(state = Initialiser.initialState.file_status, action) {
    switch (action.type) {
        case UPDATED_FILE_STATUS:
            if (_.get(action, 'file_status.error')) {
                return _.get(action, 'file_status');
            }

            return _.get(action, `file_status.fileStatusList`, []);
        default:
            return state;
    }
}
